var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { combatLogs, getNextCombatMapId, mockCombatMap } from '@/api/mockApi/_data';
export const mockCombatTrackerApi = {
    combat_map: {
        list: () => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve([mockCombatMap]), 0));
        }),
        addCharacterToMap: (combatMapId, characterId, initiative) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve(true), 0));
        }),
        removeCharacterFromMap: (combatMapId, characterId) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve(true), 0));
        }),
        getCombatMapByRoomId: (roomId) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve(Object.assign(Object.assign({}, mockCombatMap), { id: roomId })), 0));
        }),
        get: (id) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve(Object.assign(Object.assign({}, mockCombatMap), { id })), 0));
        }),
        create: (data) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve(Object.assign(Object.assign({}, data), { id: getNextCombatMapId() })), 0));
        }),
        update: (id, data) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve(Object.assign(Object.assign({}, data), { id })), 0));
        }),
        delete: (id) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve({ id }), 0));
        }),
    },
    combat_map_character_data: {
        list: (mapId) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve([]), 0));
        }),
        update_character_data: (data) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve({ data }), 0));
        }),
        get: (mapId, characterId) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve({ mapId, characterId, data: {} }), 0));
        }),
        create: (mapId, data) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve(Object.assign(Object.assign({}, data), { mapId, id: getNextCombatMapId() })), 0));
        }),
        update: (mapId, characterId, data) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve(Object.assign(Object.assign({}, data), { mapId, characterId })), 0));
        }),
        delete: (mapId, characterId) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve({ mapId, characterId }), 0));
        }),
    },
    combat_map_logs: {
        list: (params) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve(combatLogs), 300));
        }),
        create: (data) => __awaiter(void 0, void 0, void 0, function* () {
            const newLog = Object.assign(Object.assign({}, data), { createdAt: new Date().toISOString() });
            return new Promise((resolve) => setTimeout(() => resolve(newLog), 300));
        }),
        clear: (combatMapId) => __awaiter(void 0, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(() => resolve({ message: 'Logs cleared' }), 300));
        }),
    },
};
